import { Component } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { FooterService } from "../../services/footer.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"
import { InformationModalComponent } from "../modals/information-modal/information-modal.component"

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.less"],
})
export class FooterComponent extends EduComponent {
    public feedbackFormHtml = null
    public gtmPrefix: string = "gtm-footer-"
    public isStudent: boolean
    public pbsLogoWhite
    public currentYear

    constructor(
        private footerService: FooterService,
        private modalService: NgbModal,
        public userService: UserService
    ) {
        super()
        this.pbsLogoWhite = require("../../../assets/PBS-logo-white.svg").default
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()
        this.currentYear = Utils.getCurrentYear()
    }

    public buildFeedbackForm(event) {
        event.preventDefault()
        this.addSub(
            this.footerService.getFeedbackFormHtml().subscribe((response) => {
                this.feedbackFormHtml = response
            })
        )
    }

    public subscribe() {
        const settings = (window as any).PBSLM.eloqua.footer
        const subscribeBtn = document.getElementById("eloqua-newsletter-go")
        if (subscribeBtn.getAttribute("disabled") === "true") {
            return
        }
        const email = (document.getElementById("email-eloqua-newsletter") as HTMLInputElement).value
        subscribeBtn.classList.add("disabled")
        subscribeBtn.setAttribute("disabled", "true")

        this.addSub(
            this.footerService
                .subscribeToNewsletter(
                    settings.url,
                    settings.elqFormName,
                    settings.elqSiteId,
                    email
                )
                .subscribe(
                    (response) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        const informationModal = this.modalService.open(InformationModalComponent)
                        informationModal.componentInstance.message =
                            "You have been subscribed to the newsletter!"
                    },
                    (error) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        const informationModal = this.modalService.open(InformationModalComponent)
                        informationModal.componentInstance.message =
                            "Something went wrong. Please try again later."
                    }
                )
        )
    }

    public submitForm() {
        const csrfmiddlewaretoken = (document.querySelector(
            "#feedback_form input[name='csrfmiddlewaretoken']"
        ) as HTMLInputElement).value
        const name = (document.getElementById("id_name") as HTMLInputElement).value
        const email = (document.getElementById("id_email") as HTMLInputElement).value
        const comment = (document.getElementById("id_comment") as HTMLInputElement).value
        const captchaResponse = (document.getElementById(
            "g-recaptcha-response"
        ) as HTMLInputElement).value
        this.addSub(
            this.footerService
                .submitFeedback(csrfmiddlewaretoken, name, email, comment, captchaResponse)
                .subscribe((response) => {
                    this.feedbackFormHtml = response
                })
        )
    }
}
